import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {Provider} from 'react-redux'
import store from '../src/store'
import {auth} from './firebase'
import {autoLoginTest} from "./store/actions/auth";

auth.onAuthStateChanged(async user => {
    if (user) {
        store.dispatch(autoLoginTest(user)).then(res => {
        }).catch(err => {
        })
    }
})

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <App/>
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
